module.exports = __webpack_public_path__ + "img/arow_up.712ede3f.svg";